
export default {
  data() {
    return {
      groupsCount: 3,
      showAll: false,
      forceCountPerColumn: 0,
    };
  },

  computed: {
    dictionary() {
      return this.$store.getters["sliders/getDictionary"];
    },

    groups() {
      if (this.showAll) {
        return [this.dictionary];
      }

      const groups = [];
      const countPerColumn =
        this.forceCountPerColumn ||
        Math.ceil(this.dictionary.length / this.groupsCount);

      for (let i = 0; i < this.groupsCount; i++) {
        groups.push(
          this.dictionary.slice(i * countPerColumn, (i + 1) * countPerColumn)
        );
      }

      return groups;
    },
  },
  mounted() {
    if (window.innerWidth < 1024) {
      this.groupsCount = 1;
      this.forceCountPerColumn = 3;
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 1024) {
        this.groupsCount = 1;
        this.forceCountPerColumn = 3;
      } else {
        this.groupsCount = 3;
        this.showAll = false;
      }
    });
  },
  methods: {},
};
